import styles from "../ultimos_casos_reclamados/filtros.module.css";
import {Button, Form} from "react-bootstrap";
import LangContext from "../../../context/LangContext";
import {useContext, useEffect} from "react";
import {useParamsUrl} from "../../mantenedores/useParamsUrl";
import {urlConfig} from "../../../config/urlConfig";
import axios from "axios";
import {toast} from "react-toastify";
import DBContext from "../../../context/DBContext";

export const FiltroStuffing = ({perPage,url,setUrl,active,setActive,listaStuffing,setListaStuffing}) => {
    const {stuffing, setStuffing, cambioStuffing,setCambioStuffing} = useContext(DBContext);
    //const {searchUrl, handleSearch,params} = useParamsUrl(`${urlConfig.allUrl}:9003/api/v1/stuffings/me`);
    const {searchUrl, handleSearch,params} = useParamsUrl(`${urlConfig.stuffingUrl}:9003/api/v1/stuffings/me`);

    const {traduccion} = useContext(LangContext)

    useEffect(() => {
        setCambioStuffing(!cambioStuffing);
    },[])

    const searchStuffing = () => {
        setActive(0);
        let newUrl =`${searchUrl}&size=${perPage}&page=${0}`;
        setUrl(newUrl);
        //console.log("searchUrl Con el Boton",newUrl)
        return axios.get(newUrl, {
            headers: {
                Authorization: localStorage.getItem("token").replace("Bearer ", "")
            }
        }).then((res) => {
            setStuffing(res.data.data);
            setListaStuffing(res.data.data);
        }).catch((error) => {
            //console.log(error);
            toast.error(`${traduccion?.errores?.erroralFiltrarIntente}`, {
                position: toast.POSITION.TOP_RIGHT
            })
        });
    }

    return (
        <>
            <div className={styles.filtro_total}>
                <p className={styles.title_claimed}>{traduccion.stuffingFilter?.stuffingReport}</p>
                <div className={styles.filtros_busqueda}>
                    <p className={styles.title_filter}>{traduccion.stuffingFilter?.searchFilter}</p>
                    <div className={styles.opciones_busqueda}>
                        <Form action="/api/claimed" method="post" >
                            <div>
                                <label htmlFor="container_select">{traduccion.stuffingFilter?.ordenEmbarque}</label>
                                <Form.Control size="sm" name={"order"} type={"text"}
                                              onChange={handleSearch}
                                              className={styles.selects_input}/>

                            </div>
                            <div>
                                <label htmlFor="container_select">{traduccion.stuffingFilter?.nContainer}</label>
                                <Form.Control size="sm" name={"container"} type={"text"}
                                              onChange={handleSearch}
                                              className={styles.selects_input}/>

                            </div>

                            <div className={styles.opciones_date}>
                                <div className={styles.opciones_date_in}>
                                    <Form.Label
                                        htmlFor="fechaReporteStart">{traduccion.stuffingFilter?.fechaReporte}</Form.Label>
                                    <Form.Control
                                        name="from"
                                        onChange={handleSearch}
                                        size="sm"
                                        type="date"
                                        id="fechaReporteStart"
                                        placeholder={traduccion?.factura?.desde}
                                    />
                                </div>
                                <div className={styles.opciones_date_in}>
                                    <Form.Control
                                        name="to"
                                        onChange={handleSearch}
                                        size="sm"
                                        type="date"
                                        id="fechaReporteEnd"
                                        placeholder={traduccion?.factura?.hasta}
                                    />
                                </div>
                            </div>
                            <Button className={styles.boton_filtro} variant="primary" onClick={searchStuffing}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M13.5233 12.4628L16.7355 15.6743L15.6743 16.7355L12.4628 13.5233C11.2678 14.4812 9.7815 15.0022 8.25 15C4.524 15 1.5 11.976 1.5 8.25C1.5 4.524 4.524 1.5 8.25 1.5C11.976 1.5 15 4.524 15 8.25C15.0022 9.7815 14.4812 11.2678 13.5233 12.4628ZM12.0188 11.9063C12.9706 10.9274 13.5022 9.61532 13.5 8.25C13.5 5.349 11.1503 3 8.25 3C5.349 3 3 5.349 3 8.25C3 11.1503 5.349 13.5 8.25 13.5C9.61532 13.5022 10.9274 12.9706 11.9063 12.0188L12.0188 11.9063Z"
                                        fill="white"/>
                                </svg>
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    )
}
